/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface Login200Response
 */
export interface Login200Response {
    /**
     * A short-lived token that can be used to authenticate requests
     * @type {string}
     * @memberof Login200Response
     */
    token?: string;
    /**
     * A longer-lived token that can be used to refresh the bearer token
     * @type {string}
     * @memberof Login200Response
     */
    refreshToken?: string;
}


/**
 * Check if a given object implements the Login200Response interface.
 */
export function instanceOfLogin200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function Login200ResponseFromJSON(json: any): Login200Response {
    return Login200ResponseFromJSONTyped(json, false);
}

export function Login200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Login200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'token': !exists(json, 'token') ? undefined : json['token'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
    };
}

export function Login200ResponseToJSON(value?: Login200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'token': value.token,
        'refreshToken': value.refreshToken,
    };
}

